module.exports = function reducer_StreamChannels(state = []) {
    return state;
};
